// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("icons/icomoon.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("icons/icomoon.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("icons/icomoon.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("icons/icomoon.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("icons/icomoon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'veritone-icons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

[class^='icon-engine-'],
[class*=' icon-engine-'] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'engine-icons' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-engine-transcription:before {
  content: '\\e900';
}
.icon-engine-sentiment:before {
  content: '\\e901';
}
.icon-engine-fingerprint:before {
  content: '\\e902';
}
.icon-engine-face:before {
  content: '\\e903';
}
.icon-engine-object-detection:before {
  content: '\\e904';
}
.icon-engine-translation:before {
  content: '\\e905';
}
.icon-engine-music-detection:before {
  content: '\\e906';
}
.icon-engine-gps:before {
  content: '\\e907';
}
.icon-engine-tag:before {
  content: '\\e908';
}
.icon-engine-audio-detection:before {
  content: '\\e909';
}
.icon-engine-logo-detection:before {
  content: '\\e90a';
}
.icon-engine-transcode:before {
  content: '\\e90c';
}
.icon-engine-ingestion:before {
  content: '\\e90b';
}
`, "",{"version":3,"sources":["webpack://./resources/styles/veritone-engines.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,4CAA6B;EAC7B;;;;yDAIwC;EACxC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,+EAA+E;EAC/E,sCAAsC;EACtC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'veritone-icons';\n  src: url('icons/icomoon.eot');\n  src: url('icons/icomoon.eot') format('embedded-opentype'),\n    url('icons/icomoon.woff2') format('woff2'),\n    url('icons/icomoon.ttf') format('truetype'),\n    url('icons/icomoon.woff') format('woff'),\n    url('icons/icomoon.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n[class^='icon-engine-'],\n[class*=' icon-engine-'] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'engine-icons' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-engine-transcription:before {\n  content: '\\e900';\n}\n.icon-engine-sentiment:before {\n  content: '\\e901';\n}\n.icon-engine-fingerprint:before {\n  content: '\\e902';\n}\n.icon-engine-face:before {\n  content: '\\e903';\n}\n.icon-engine-object-detection:before {\n  content: '\\e904';\n}\n.icon-engine-translation:before {\n  content: '\\e905';\n}\n.icon-engine-music-detection:before {\n  content: '\\e906';\n}\n.icon-engine-gps:before {\n  content: '\\e907';\n}\n.icon-engine-tag:before {\n  content: '\\e908';\n}\n.icon-engine-audio-detection:before {\n  content: '\\e909';\n}\n.icon-engine-logo-detection:before {\n  content: '\\e90a';\n}\n.icon-engine-transcode:before {\n  content: '\\e90c';\n}\n.icon-engine-ingestion:before {\n  content: '\\e90b';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
